import Vue from "vue/dist/vue.esm";
import StarQueryIcon from "components/star-query-icon";

let starIcon;

export const mountStarQueryIcon = (queryBody) => {
  const $container = document.querySelector(".js-star-query-icon");

  if(starIcon) {
    starIcon.$refs.star_icon.query = queryBody;
    starIcon.$refs.star_icon.starred = false;
  } else if ($container) {
    starIcon = new Vue({
      el: $container,
      render: h => h(StarQueryIcon, {
        ref: "star_icon",
        props: {
          queryBody
        }
      })
    });
  }
}
